export const sleep = (delay = 2000) =>
  new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
